<div
  [style]="signatureStyle"
  [style.top]="reportSignature.top"
  [style.left]="reportSignature.left"
  [style.width]="reportSignature.width"
  [style.height]="reportSignature.height"
  [style.z-index]="reportSignature.zIndex"
  [style.border-width]="reportSignature.borderWidth + 'mm'"
  [style.border]="reportSignature.borderStyle"
  [style.border-color]="reportSignature.borderColor"
  (click)="onClick($event)"
  draggable="true"
  (dragstart)="onDragStart($event)"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
>
  <div [style.padding]="'3mm'">
    <span>Signature</span>
  </div>
  <div [style.height]="'20mm'">
    <div [style.margin]="'3mm'" [style.height]="'16mm'" [style.border-bottom]="'1px solid black'" [style.float]="'right'"></div>
  </div>
  <div [style.padding]="'1mm 3mm'">
    <label [style.width]="'30mm'" [style.text-align]="'center'">Name</label>
    <span>[User's name]</span>
  </div>
  <div [style.padding]="'1mm 3mm'">
    <label [style.width]="'30mm'" [style.text-align]="'center'">Date</label>
    <span>[Current date]</span>
  </div>
</div>
